import {
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Stack,
  Text,
} from '@chakra-ui/react';

import { OcrScanAnimation } from './OcrScanAnimation';

interface OcrUploadLoadingModalProps {
  isOpen: boolean;
}

export const OcrUploadLoadingModal = ({
  isOpen,
}: OcrUploadLoadingModalProps) => (
  <Modal
    isCentered
    closeOnEsc={false}
    closeOnOverlayClick={false}
    isOpen={isOpen}
    onClose={() => undefined}
  >
    <ModalOverlay backdropFilter="blur(4px)" bg="rgba(27, 31, 38, 0.72)" />
    <ModalContent
      bg="white"
      borderRadius="12px"
      boxShadow="0px 4px 16px rgba(27, 31, 38, 0.12)"
      h="272px"
      maxW="366px"
      mx={4}
      p={0}
    >
      <ModalBody display="flex" px="24px" py="32px">
        <Stack align="center" justify="center" spacing="24px" w="full">
          {isOpen ? <OcrScanAnimation /> : null}

          <Stack alignSelf="stretch" spacing={2}>
            <Text
              color="#373F41"
              fontSize="20px"
              fontWeight={600}
              lineHeight="28px"
              textAlign="center"
            >
              Mengunggah & menganalisa bukti transfer ...
            </Text>
            <Text
              color="#373F41"
              fontSize="16px"
              fontWeight={400}
              lineHeight="24px"
              textAlign="center"
            >
              Jangan menutup atau meninggalkan halaman demi kelancaran proses
              unggah.
            </Text>
          </Stack>
        </Stack>
      </ModalBody>
    </ModalContent>
  </Modal>
);
